import endpointMaker from "appredux/endpoints";
import request from "http/request";

export type UserBasicInfo = {
  firstname: string;
  lastname: string;
};

export class UserService {
  async updateUserBasicInfo(userInfo: UserBasicInfo) {
    const farm = localStorage.getItem("farm");
    return request.postJson(
      `${endpointMaker.api.baseUrl}/userInfo.php?task=update_user_basic_info&farm=${farm}`,
      JSON.stringify(userInfo)
    );
  }

  async updateUserPassword(password: string, email: string, token: string) {
    const response = await fetch(
      `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/updatePassword.php`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          task: "resetPasswordRequest",
          password: password,
          email: email,
          token: token,
        }),
      }
    );

    return response.json();
  }

  async updateUserFarmcode(currentFarmcode: string, newFarmcode: string) {
    await request.postJson(
      `${endpointMaker.api.baseUrl}/farm/?task=changeFarmName`,
      JSON.stringify({
        currentName: currentFarmcode,
        newName: newFarmcode,
      })
    );
  }

  async isInternalUser($email: string) {
    if (!$email) return false;
    const email = $email.toLowerCase();
    return (
      email.endsWith("@equitrace.com") ||
      email.endsWith("@equitrace.app") ||
      email.endsWith("@ardanis.com")
    );
  }
}

export const userService = new UserService();
